// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flash-enter-active[data-v-051a020a],.flash-leave-active[data-v-051a020a]{transition:background-color .5s ease-in-out,transform .5s ease}.flash-enter-active[data-v-051a020a]{transition-delay:.5s}.flash-enter[data-v-051a020a],.flash-leave-to[data-v-051a020a]{background-color:rgba(218,85,101,.1)}.flash-enter-to[data-v-051a020a],.flash-leave[data-v-051a020a]{background-color:#16181d}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
